module.exports = __webpack_public_path__ + "img/logo_white.96ec9159.png";